import { render, staticRenderFns } from "./DemoMobileStream.vue?vue&type=template&id=04b64555&scoped=true&"
import script from "./DemoMobileStream.vue?vue&type=script&lang=js&"
export * from "./DemoMobileStream.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b64555",
  null
  
)

export default component.exports